import * as React from 'preact/compat'
import Consent from '../Consent'
import type { DialogComponentPropTypes } from '../AuthDialog'
import styles from '../../../../css/auth.pcss.json'
import buttons from '../../../../css/buttons.pcss.json'
import SVG from '../../SVG'
import { loadStylesheet } from '../../../common/helpers'

declare global {
  interface Window {
    setAuthInfo: DialogComponentPropTypes['setAuthInfo']
    setAuthPage: DialogComponentPropTypes['switchPage']
  }
}

interface StateProps {
  showAdditional: boolean
}

class PageMain extends React.Component<DialogComponentPropTypes, StateProps> {

  state: StateProps = {
    showAdditional: false
  }

  window: WindowProxy

  componentWillMount() {
    if ("paintWorklet" in CSS && !window.squircleInited) {
      window.squircleInited = true
      // noinspection JSIgnoredPromiseFromCall
      CSS.paintWorklet.addModule(
        "https://www.unpkg.com/css-houdini-squircle@0.2.2/squircle.min.js"
      );
    }
    // noinspection JSIgnoredPromiseFromCall
    loadStylesheet('buttons')
  }

  componentDidMount() {
    window.setAuthInfo = this.props.setAuthInfo
    window.setAuthPage = this.props.switchPage
  }

  login = (provider: string) => {
    let domain = ''
    const domainMeta = document.querySelector('meta[name=ajax-domain]')
    if (domainMeta) {
      domain = domainMeta.getAttribute('content')
    }
    const left = screen.width / 2 - 360
    const top = screen.height / 2 - 220
    window.open(`${domain}/auth/${provider}`, 'sg_social_auth', `width=720,height=440,left=${left},top=${top}modal=yes,alwaysRaised=yes`)
    window.onmessage = (ev: Event & {
      data: string
    }) => {
      try {
        if (typeof ev.data !== 'string') {
          return
        }
        let message = window.atob(ev.data)
        let data = JSON.parse(message) as {
          action: string,
          params: any
        }
        switch (data.action) {
          case 'setAuthInfo':
            this.props.setAuthInfo(data.params.user)
            break
          case 'setAuthPage':
            this.props.switchPage(data.params.page)
            break
          case 'reloadWindow':
            window.location.reload()
            break
        }
      } catch (ex) {
        console.error(ex, { data: ev.data })
      }
    }
  }

  loginVkontakte = () => this.login('vkontakte')
  loginGoogle = () => this.login('google')
  loginMailRu = () => this.login('mailru')
  loginYandex = () => this.login('yandex')
  loginOdnoklassniki = () => this.login('odnoklassniki')
  loginSteam = () => this.login('steam')
  /*loginFacebook = () => this.login('facebook')*/
  loginStopGame = () => this.props.switchPage('login')
  goToRegister = () => this.props.switchPage('register')

  render() {
    const isLoggedIn = window.isLoggedIn

    return <>
      <div style='display: flex; flex-direction: column; align-items: center'>
        <div className={styles['auth-header']}>
          <h1>{isLoggedIn ? 'Привязка социального аккаунта' : 'Вход на StopGame'}</h1>
        </div>
        <p className={styles['subtitle']}>Войти через аккаунт</p>
        <div className={styles['auth-social-buttons']}>
          {!isLoggedIn
            && <button onClick={this.loginStopGame} className={styles['auth-social-button']}>
              <SVG i='auth/stopgame'/>
            </button>
          }
          <button onClick={this.loginSteam} className={styles['auth-social-button']}>
            <SVG i='auth/steam'/>
          </button>
          <button onClick={this.loginVkontakte} className={styles['auth-social-button']}>
            <SVG i='auth/vk'/>
          </button>
          <button onClick={this.loginGoogle} className={styles['auth-social-button']}>
            <SVG i='auth/google'/>
          </button>
          {/*<button onClick={this.loginFacebook} className={styles['auth-social-button']}>
            <SVG i='auth/facebook' />
          </button>*/}
          <button onClick={this.loginYandex} className={styles['auth-social-button']}>
            <SVG i='auth/yandex'/>
          </button>
          <button onClick={this.loginMailRu} className={styles['auth-social-button']}>
            <SVG i='auth/mailru'/>
          </button>
          <button onClick={this.loginOdnoklassniki} className={styles['auth-social-button']}>
            <SVG i='auth/odnoklassniki'/>
          </button>
        </div>
        {!isLoggedIn && <button
          type='button'
          className={buttons['low-contrast']}
          onClick={this.goToRegister}
          style='margin-top: 48px;'
        >
          <SVG i='sg/logo-small'/>
          Зарегистрироваться
        </button>}
      </div>
      {!isLoggedIn && <Consent/>}
    </>
  }
}

export default PageMain
